export class SiterecordCoordinatesChange {
  lat: string;
  lon: string;
  bearing: number;

  constructor(lat: string, lon: string, bearing: number) {
    this.lat = lat;
    this.lon = lon;
    this.bearing = bearing;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/siterecord-coordinates-change.model.ts